// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"History_wrapper__30fga"};